/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';

// @ts-ignore
import {GenerateProductAssetUrl,GetLocalizedText} from './../../themes/kent/utilities/functions';

// @ts-ignore
import BackButton from './../back-button/./back-button';

//@ts-ignore
import {GetProductsBySubCategory,GetProductsByCategory, GetProductsBySlugs} from './../../themes/kent/utilities/dataFunctions';

// @ts-ignore
import HorizontalProductScroller from "./../horizontal-product-scroller/./horizontal-product-scroller";

interface IProps {
  columns?:any;
  year?:any;
  active?:any;
  dismissed?:any;
  theme?:any;
}

interface IState {
  ready:boolean;
  columns?:any;
  productSelectorActive?:any;
  productSelectorSlot?:any;
  productSelectorProducts?:any;
  productSelectorColumnIndex?:any;
  productSelectorSlotIndex?:any;
  initialSystemTrimCompleted?:any;
  updateKey?:any;
}


/**
 *
 * Hero component
 * @extends {React.Component}
 */
class PackageBuilder extends React.Component<IProps> {
  public state: IState;

  constructor(props: IProps) {
    super(props);
    this.state = {
      ready:false,
      updateKey:101
    };
  }

  public componentDidMount = () => {
    this.setupScreen()
    setTimeout(
      () => {
        this.setState({
          ready:true
        });
      },
      100);
  }

  public setupScreen = async () =>{
    let columns:any = [];
    if(this.props.columns){
      for (let index = 0; index < this.props.columns.length; index++) {
        const column:any = this.props.columns[index];
        columns[index] = {slots:[]}
        if(column.slots){
          for (let i = 0; i < column.slots.length; i++) {
            let slot:any = column.slots[i];
            let products:any =[];
            if(slot.categoryId && slot.categoryId != ''){
              if(slot.categoryId.indexOf(',') != -1){
                let categories:any = slot.categoryId.split(',');
                for (let index = 0; index < categories.length; index++) {
                  let categoryProducts:any = await GetProductsByCategory(categories[index], this.props.year)
                  for (let x = 0; x < categoryProducts.length; x++) {
                    products.push(categoryProducts[x])
                  }
                }
              } else{
                products = await GetProductsByCategory(slot.categoryId, this.props.year)
              }
            }
            if(slot.subcategoryId && slot.subcategoryId != ''){
              if(slot.subcategoryId.indexOf(',') != -1){
                let subcategories:any = slot.subcategoryId.split(',');
                for (let index = 0; index < subcategories.length; index++) {
                  let subcategoryProducts:any = await GetProductsByCategory(subcategories[index], this.props.year)
                  for (let x = 0; x < subcategoryProducts.length; x++) {
                    products.push(subcategoryProducts[x])
                  }
                }
              } else{
                products = await GetProductsByCategory(slot.subcategoryId, this.props.year)
              }
            }
            if(slot.slugList && slot.slugList.length > 0){
              let productArray:any = [];
              for (let x = 0; x < slot.slugList.length; x++) {
                productArray.push(slot.slugList[x])
              }
              products = await GetProductsBySlugs(productArray, this.props.year)
            }
            let heightClass:any = slot.height ? 'slot-full-height' : 'slot-'+slot.height+'-height';
            let selectedProduct:any = products[0] ? products[0] : '';
            let selectedProductTitle:any = selectedProduct ? await GetLocalizedText(selectedProduct.attributes.content,'title') : '';
            let prodAssetUrl:any = await GenerateProductAssetUrl(this.props.year);
            let selectedProductImage: any = selectedProduct ? prodAssetUrl+selectedProduct.attributes.slug+'1_1000.png':'';
            columns[index].slots.push({
              title:slot.title,
              slotIndex:index,
              heightClass:heightClass,
              selectedProduct:selectedProduct,
              selectedProductTitle:selectedProductTitle,
              selectedProductImage:selectedProductImage,
              subcategoryId:slot.subcategoryId,
              categoryId:slot.categoryId,
              slugList:slot.slugList,
              products:products
            })
          }
        }
      }
      this.setState({
        columns:columns
      },()=>{
        this.checkForSystems();
      })
    }
  }
  public updateSlot = (columnIndex:any,slotIndex:any) =>{
    let slot:any = this.state.columns[columnIndex].slots[slotIndex];
    if(slot){
      this.setState({
        productSelectorColumnIndex:columnIndex,
        productSelectorSlotIndex:slotIndex,
        productSelectorActive:true,
        productSelectorProducts:slot.products,
        productSelectorSlot:slot
      },()=>{
        this.checkForSystems();
      })
    }
  }
  public onUpdateSlot = async (productIndex:any) =>{
    let columns:any = this.state.columns;
    for (let i = 0; i < columns.length; i++) {
      if(i == this.state.productSelectorColumnIndex){
        let slots:any = columns[i].slots;
        for (let x = 0; x < slots.length; x++) {
          if(x == this.state.productSelectorSlotIndex){
            let selectedProduct:any = this.state.productSelectorProducts[productIndex];
            let selectedProductTitle:any = await GetLocalizedText(selectedProduct.attributes.content,'title');
            let prodAssetUrl:any = await GenerateProductAssetUrl(this.props.year);
            let selectedProductImage: any = prodAssetUrl+selectedProduct.attributes.slug+'1_500.png';
            columns[i].slots[x].selectedProduct = selectedProduct;
            columns[i].slots[x].selectedProductTitle = selectedProductTitle;
            columns[i].slots[x].selectedProductImage = selectedProductImage;
          }
        }
      }
    }
    this.setState({
      columns:columns,
      productSelectorActive:false,
      productSelectorProducts:null,
      productSelectorColumnIndex:null,
      productSelectorSlotIndex:null,
      updateKey:this.state.updateKey +1
    },()=>{
      this.checkForSystems();
    })
  }

  public checkForSystems = async () =>{
    let columns:any = this.state.columns;
    let systemsFound:any = false;
    let initialSystemTrimCompleted:any = this.state.initialSystemTrimCompleted;
    for (let i = 0;  i < columns.length; i++) {
      let column:any = this.state.columns[i];
      let slots:any = column.slots;
      for (let x = 0; x < slots.length; x++) {
        let slot:any = slots[x];
        if(slot.categoryId == "z6DqA3NDcD"){
          let systemProductArray:any = ['wakeboard-boots-system-lowback-graphite','wakeboard-boots-system-pro-black'];
          let nonSystemProducts:any = slot.products.filter((prod:any) => systemProductArray.indexOf(prod.attributes.slug) == -1);
          let prodAssetUrl:any = await GenerateProductAssetUrl(this.props.year);
          if(!initialSystemTrimCompleted){
            initialSystemTrimCompleted = true
            columns[i].slots[x].products = nonSystemProducts
            columns[i].slots[x].selectedProduct = nonSystemProducts[0]
            columns[i].slots[x].selectedProductTitle = await GetLocalizedText(columns[i].slots[x].selectedProduct.attributes.content,'title');
            columns[i].slots[x].selectedProductImage = prodAssetUrl+columns[i].slots[x].selectedProduct.attributes.slug+'1_500.png';
          }
          if(columns[i].slots[x].selectedProduct){
            if(columns[i].slots[x].selectedProduct.attributes.subcategory == "ZzqDBJBKQQ" && !slot.slugList){
              systemsFound = true
            }
          }
        }
        if(slot.slugList && slot.slugList.length > 0){
          if(slot.slugList.indexOf('wakeboard-boots-system-lowback-graphite') != -1){
           if(!systemsFound){
             columns[i].slots[x].hide = true
           } else{
             columns[i].slots[x].hide = false
           }
         }
        }
      }
    }
    this.setState({
      columns:columns,
      updateKey:this.state.updateKey +1,
      initialSystemTrimCompleted:initialSystemTrimCompleted
    })
  }

  public dismissSelector = async () =>{
    this.setState({
      productSelectorActive:false,
      productSelectorProducts:null,
      productSelectorColumnIndex:null,
      productSelectorSlotIndex:null
    })
  }


  public render(): JSX.Element {
    let readyClass = this.state.ready ? 'active' : '';
    let theme = this.props.theme ? this.props.theme : "dark";
    console.log(this.state.columns)
    return (
      <div style={{width:'100vw',overflowX:'scroll'}}>
        <div key={this.state.updateKey} className={"package-builder-container "+readyClass+' '+theme} style={{minWidth:800}}>
          <BackButton />
          {this.state.columns && this.state.columns.map((column:any,index:any) =>{
            let columnIndex:any = index;
            return(
              <div className={"slot-column"}>
                {column.slots && column.slots.map((slot:any,index:any) =>{
                  let slotIndex:any = index;
                  if(!slot.hide){
                    return(
                      <div className={"slot "+slot.heightClass} style={{backgroundImage:'url('+slot.selectedProductImage+')'}}>
                        <div className="slot-meta-container">
                          {slot.title && <div className="slot-category white-color">{slot.title}</div>}
                          {slot.selectedProductTitle && <div className="slot-title white-color">{slot.selectedProductTitle}</div>}
                          <div  onClick={()=>this.updateSlot(columnIndex,slotIndex)} className="slot-change-button">{'Change'}</div>
                        </div>
                      </div>
                    )
                  } else{
                    return <span />
                  }
                })}
              </div>
            )
          })}
          {this.state.productSelectorActive &&
            <HorizontalProductScroller blockProductClick={true} onProductClick={this.onUpdateSlot} year={this.props.year} theme={'dark'} active={this.state.productSelectorActive} products={this.state.productSelectorProducts} dismissed={this.dismissSelector} />
          }
        </div>
      </div>
    );
  }
}

export default PackageBuilder;
